import React from 'react';

export const PaymentLogos: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <div className={`flex flex-wrap items-center gap-2.5 ${className}`}>
      {/* Visa */}
      <div 
        className="h-7 px-2.5 bg-white rounded-md border border-slate-200 shadow-2xs flex items-center justify-center"
        title="Visa"
      >
        <svg className="h-3.5 w-auto" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.125 1.054L13.125 14.946H9.172L5.594 3.75C5.375 2.875 5.172 2.547 4.5 2.188C3.39 1.594 1.594 1.047 0 0.703L0.094 0.25H7.031C7.922 0.25 8.719 0.844 8.906 1.844L10.609 10.875L14.781 0.25H19.125V1.054Z" fill="#1A1F71"/>
          <path d="M26.797 10.375C26.828 6.547 21.469 6.328 21.5 4.547C21.516 4 22.016 3.422 23.109 3.281C23.656 3.203 25.172 3.141 26.828 3.906L27.484 0.859C26.594 0.531 25.438 0.219 23.969 0.219C17.781 0.219 17.391 4.875 17.391 6.844C17.391 10.828 22.844 11.047 22.844 13.063C22.844 13.828 21.938 14.344 20.891 14.344C19.266 14.344 17.703 13.625 16.922 13.25L16.234 16.344C17.203 16.781 18.984 17.156 20.813 17.156C27.297 17.156 26.797 12.516 26.797 10.375Z" fill="#1A1F71"/>
          <path d="M34.828 0.25H31.469C30.438 0.25 29.672 0.844 29.281 1.766L23.469 15.547H27.578L28.391 13.297H33.406L33.875 15.547H37.5L34.828 0.25ZM29.531 10.156L31.594 4.453L32.781 10.156H29.531Z" fill="#1A1F71"/>
          <path d="M44.094 0.25L40.938 15.547H37.031L40.188 0.25H44.094Z" fill="#1A1F71"/>
        </svg>
      </div>

      {/* Mastercard */}
      <div 
        className="h-7 px-2.5 bg-white rounded-md border border-slate-200 shadow-2xs flex items-center justify-center"
        title="Mastercard"
      >
        <svg className="h-4 w-auto" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="10" fill="#EB001B"/>
          <circle cx="22" cy="10" r="10" fill="#F79E1B"/>
          <path d="M16 3.10547C17.8867 4.79688 19.0938 7.25781 19.0938 10C19.0938 12.7422 17.8867 15.2031 16 16.8945C14.1133 15.2031 12.9062 12.7422 12.9062 10C12.9062 7.25781 14.1133 4.79688 16 3.10547Z" fill="#FF5F00"/>
        </svg>
      </div>

      {/* Verve */}
      <div 
        className="h-7 px-2 bg-slate-900 rounded-md border border-slate-800 shadow-2xs flex items-center gap-1"
        title="Verve"
      >
        <span className="w-2.5 h-2.5 rounded-full bg-red-500" />
        <span className="text-[11px] font-black tracking-tighter text-white">verve</span>
      </div>

      {/* American Express */}
      <div 
        className="h-7 px-2 bg-[#006FCF] rounded-md border border-sky-700 shadow-2xs flex items-center justify-center"
        title="American Express"
      >
        <span className="text-[10px] font-black tracking-tight text-white uppercase">AMEX</span>
      </div>

      {/* Paystack Badge */}
      <div 
        className="h-7 px-2.5 bg-slate-900 rounded-md border border-slate-800 shadow-2xs flex items-center gap-1.5"
        title="Paystack Secured"
      >
        {/* Paystack Icon */}
        <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 5H18C19.1046 5 20 5.89543 20 7C20 8.10457 19.1046 9 18 9H2V5Z" fill="#00C3F7"/>
          <path d="M2 11H22C23.1046 11 24 11.8954 24 13C24 14.1046 23.1046 15 22 15H2V11Z" fill="#00C3F7"/>
          <path d="M2 17H14C15.1046 17 16 17.8954 16 19C16 20.1046 15.1046 21 14 21H2V17Z" fill="#00C3F7"/>
        </svg>
        <span className="text-[11px] font-bold text-white tracking-tight">paystack</span>
      </div>
    </div>
  );
};
